module.exports = __webpack_public_path__ + "static/media/chrysler-300c-2007-side.9652aacd.jpg";